export default __webpack_public_path__ + "706b84159502326459ff2f1f3e810d25.png";